import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
// import { formatRoute } from 'react-router-named-routes';

import {
  Paper,
  Typography,
  // Button,
  CircularProgress,
} from '@material-ui/core';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import FormErrorDialog from '../../common/components/formErrorDialog';
import * as profileActions from '../actions';
// import * as constants from '../../config/constants';
// import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

import DeleteProfileForm from '../components/DeleteProfileForm';


class DeleteProfile extends Component {
  componentDidMount() {
    document.title = 'Delete Profile';
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  inputChangedHandler = (event, field) => {
    this.props.inputChangedHandler(
      event,
      field,
      'deleteProfile',
      this.props.deleteProfile,
    );
  }

  submitHandler = (event) => {
    this.props.submitHandler(
      event,
      'deleteProfile',
      this.props.deleteProfile,
      this.props.token,
      this.props.history,
    );
  }

  render() {
    let loading = null;
    if (this.props.loading) {
      loading = (
        <div align="center">
          <br /><br /><br />
          <CircularProgress align="center" size={50} />
          <br />
          <Typography variant="subheading">Please wait. This may take some time! <br /> Please do not refresh the page.</Typography>
        </div>
      );
    }

    let display = null;

    if (!this.props.loading) {
      display = (
        <Paper className={[classes.card, classes.padding20, classes.noBorderXS].join(' ')}>
          <Typography variant="headline" className={classes.regTitle}>Delete Profile</Typography>
          <span className={classes.titleUnderline} />
          <form method="post" onSubmit={this.submitHandler} encType="multipart/form-data">
            <DeleteProfileForm
              inputs={this.props.deleteProfile}
              inputChangedHandler={this.inputChangedHandler}
              editMode
            />
          </form>
          <br />
        </Paper>
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="home"
        dashActiveLink="profile"
        user={this.props.user}
      >
        {loading}
        {display}
        <FormErrorDialog open={this.props.hasError} handleClose={this.props.toggleError} />
      </DashboardLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.profile.loading,
    hasError: state.profile.hasError,
    errors: state.profile.errors,
    deleteProfile: state.profile.deleteProfile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleError: () => dispatch(profileActions.toggleError()),
    inputChangedHandler: (event, field, section, inputs) => dispatch(
      profileActions.inputChangedHandler(event, field, section, inputs),
    ),
    submitHandler: (event, section, inputs, token, history, editMode) => dispatch(
      profileActions.submitHandler(event, section, inputs, token, history, editMode),
    ),
    onUnmount: () => dispatch(profileActions.onUnmount()),
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteProfile));



// WEBPACK FOOTER //
// ./src/profile/containers/DeleteProfile.js